// Navbar.js
import React from 'react';
import { Link } from 'react-router-dom';
import './NavBar.css'; // Create a corresponding CSS file for styling
import logoMin from './img/logo_min_white.svg';

function NavBar() {
  return (
    <header className="header">
      <div className="logo">
        <img src={logoMin} alt="SeeOSC Logo" className="logo-image" />
      </div>
      <nav className="nav-bar">
        <a href="#hero">Home</a>
        <a href="#about">About</a>
        <a href="#features">Features</a>
        <a href="#downloads">Downloads</a>
        <a href="#contact">Contact</a>
        <Link to="/help">Help</Link>
      </nav>
    </header>
  );
}

export default NavBar;
